declare const sgSettings: any;

export function getFeedSlug(): string {
  try {
    return sgSettings.config.crossword.feedSlug;
  } catch (e) {
    return 'unknown';
  }
}
